import { render, staticRenderFns } from "./overdue-bill-info.vue?vue&type=template&id=347cf5cd&"
import script from "./overdue-bill-info.vue?vue&type=script&lang=js&"
export * from "./overdue-bill-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports